/**
 * @generated SignedSource<<6ae759422ec02a248e745c717f03ae91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditAccomodationPrices_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorInit_data" | "RoomRatesTable_data" | "RoomRatesToolbar_data">;
  readonly " $fragmentType": "PackageEditAccomodationPrices_data";
};
export type PackageEditAccomodationPrices_data$key = {
  readonly " $data"?: PackageEditAccomodationPrices_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditAccomodationPrices_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditAccomodationPrices_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesTable_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesToolbar_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesEditorInit_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "fe1365a31f8bf8f47699c117c0a6490c";

export default node;
